import { useFeedbackWorkflow } from './FeedbackWorkflowContext'
import TextArea from "../../../../components/Modules/TextArea";
import { LabelModule2 } from '../../../../components/Modules/LabelModule2';
const TextAreaInput = ({ question, criteriaId, placeholder, required, answer, handleUpdate, feedbackType }: {
    question: string,
    criteriaId: string,
    placeholder?: string,
    required?: boolean,
    answer: any,
    handleUpdate: Function,
    feedbackType: string
}) => {
    const { themeManager } = useFeedbackWorkflow();

    return (
        <div className="" key={criteriaId}>
            <LabelModule2
                htmlFor={"normalInput"}
                children={`${question}${required === true ? "*" : ""}`}
                style={{
                    ...themeManager?.getLabelStyles(),
                    color:
                        themeManager?.getLabelStyles().color,
                }}
            />
            <TextArea
                onChange={(e) => handleUpdate(e, criteriaId, "")}
                value={answer[criteriaId]}
                placeholder={placeholder || question}
                style={{
                    borderColor: themeManager.getGeneralFeedbackTextAreaStylesd(feedbackType).borderColor,
                    color: themeManager.getGeneralFeedbackTextAreaStylesd(feedbackType).color,
                    ...themeManager.getGeneralFeedbackTextAreaStylesd(feedbackType),
                }}
                required={required}
            />
        </div>
    )
}

export default TextAreaInput